import { tenantEventsUrlSchema } from "@loot-os/api-contract";
import { Button } from "@loot-os/ui/components/button";
import { Input } from "@loot-os/ui/components/input";
import { Label } from "@loot-os/ui/components/label";
import { useState } from "react";

/**
 * One https URL Loot OS POSTs an environment's events to, with its own Save. Empty saves null,
 * which stops that kind of event. `onSave` gets a callback to run once the save succeeds, which
 * drops the local draft so the field shows the saved value again.
 */
export function EventsUrlField({
  inputId,
  label,
  url,
  disabled,
  pending,
  onSave,
}: {
  inputId: string;
  label: string;
  url: string | null;
  disabled: boolean;
  pending: boolean;
  onSave: (next: string | null, onSaved: () => void) => void;
}) {
  const [draft, setDraft] = useState<string | null>(null);
  const text = draft ?? url ?? "";
  const next = text.trim() === "" ? null : text.trim();
  const invalid = next !== null && !tenantEventsUrlSchema.safeParse(next).success;

  return (
    <form
      className="grid gap-1"
      onSubmit={(e) => {
        e.preventDefault();
        if (invalid) return;
        onSave(next, () => setDraft(null));
      }}
    >
      <Label htmlFor={inputId} className="text-muted-foreground">
        {label}
      </Label>
      <div className="flex flex-wrap gap-2">
        <Input
          id={inputId}
          type="url"
          placeholder="https://"
          className="min-w-0 flex-1"
          value={text}
          disabled={disabled || pending}
          onChange={(e) => setDraft(e.target.value)}
        />
        <Button type="submit" disabled={disabled || invalid || pending || draft === null}>
          {pending ? "Saving…" : "Save"}
        </Button>
      </div>
      {invalid && <p className="text-destructive">Use an https URL.</p>}
    </form>
  );
}
